export default "__VITE_ASSET__CbNMns9c__"